<template>
  <svg
    class="halloween-web"
    :class="{ 'halloween-web-arriving': animate }"
    viewBox="0 0 600 240"
    preserveAspectRatio="none"
    aria-hidden="true"
  >
    <g v-for="(web, index) in webs" :key="index">
      <line
        v-for="(endpoint, spoke) in web.spokes"
        :key="`spoke-${spoke}`"
        :x1="web.x"
        :y1="web.y"
        :x2="endpoint.x"
        :y2="endpoint.y"
      />
      <path v-for="(ring, ringIndex) in web.rings" :key="ringIndex" :d="ring" />
    </g>
  </svg>
</template>

<script setup lang="ts">
defineProps<{ animate?: boolean }>();

function point(x: number, y: number, radius: number, angle: number) {
  return { x: x + Math.cos(angle) * radius, y: y + Math.sin(angle) * radius };
}

const webs = [
  { x: 25, y: 15, radius: 380 },
  { x: 575, y: 220, radius: 360 },
  { x: 310, y: 95, radius: 220 },
].map(({ x, y, radius }) => ({
  x,
  y,
  spokes: Array.from({ length: 12 }, (_, i) => point(x, y, radius, (i * Math.PI) / 6)),
  rings: Array.from({ length: 8 }, (_, ring) => {
    const r = ((ring + 1) * radius) / 8;
    const start = point(x, y, r, 0);
    return `M ${start.x} ${start.y} ${Array.from({ length: 12 }, (_spoke, i) => {
      const control = point(x, y, r * 0.86, ((i + 0.5) * Math.PI) / 6);
      const end = point(x, y, r, ((i + 1) * Math.PI) / 6);
      return `Q ${control.x} ${control.y} ${end.x} ${end.y}`;
    }).join(" ")} Z`;
  }),
}));
</script>

<style scoped lang="scss">
.halloween-web {
  position: absolute;
  inset: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
  fill: none;
  stroke: #d5d9e2;
  stroke-width: 1.1;
  filter: drop-shadow(0 1px 1px #352c4266);
  background: #a9a4b514;
}

.halloween-web-arriving {
  transform-origin: 50% 50%;
  animation: web-bloom 0.65s ease-out 1.4s both;
}

@keyframes web-bloom {
  from {
    opacity: 0;
    clip-path: circle(0% at 50% 50%);
  }
  to {
    opacity: 1;
    clip-path: circle(75% at 50% 50%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .halloween-web-arriving {
    animation: none;
  }
}
</style>
